import {
  ChatContextEntityRef,
  ChatContextEntityType,
} from "@mapmycustomers/shared/types/chat/ChatMessage";

// No colon, so it cannot collide with a record's key.
export const APP_CHAT_THREAD_KEY = "app";

export type ChatThreadKey =
  | `${ChatContextEntityType}:${ChatContextEntityRef["id"]}`
  | typeof APP_CHAT_THREAD_KEY;

const getChatThreadKey = (contextEntity: ChatContextEntityRef | undefined): ChatThreadKey =>
  contextEntity ? `${contextEntity.entityType}:${contextEntity.id}` : APP_CHAT_THREAD_KEY;

export const parseChatThreadKey = (
  threadKey: Exclude<ChatThreadKey, typeof APP_CHAT_THREAD_KEY>
): ChatContextEntityRef => {
  const [entityType, id] = threadKey.split(":");
  return { id: parseInt(id, 10), entityType: entityType as ChatContextEntityType };
};

export default getChatThreadKey;
